import { Controller } from '@hotwired/stimulus'

// Refund Order modal
export default class extends Controller {
  static targets = ['source', 'balance', 'amount', 'splitHint']
  static values = { sources: Object }

  connect() {
    this.update()
  }

  update() {
    this.balanceTarget.textContent = this.source.balance
    if (this.hasSplitHintTarget) this.splitHintTarget.hidden = this.sourceKey !== ''
    this.validate()
  }

  validate() {
    const cents = Math.round(parseFloat(this.amountTarget.value.replace(/[$,\s]/g, '')) * 100)
    this.submitButton.disabled = !(cents > 0 && cents <= this.source.maxCents)
  }

  // A double click would otherwise queue two refunds
  submit() {
    this.submitButton.disabled = true
  }

  get sourceKey() {
    return this.hasSourceTarget ? this.sourceTarget.value : ''
  }

  get source() {
    return this.sourcesValue[this.sourceKey]
  }

  // The footer button sits outside the form and joins it through its form attribute
  get submitButton() {
    return Array.from(this.element.elements).find(element => element.type === 'submit')
  }
}
